(ns app.front.view.group.admin.fees.util.fee-variable)


(def required-fields [:fee-variable/titles])


(def all-fields (concat required-fields
                        [:fee-variable/identifier
                         :fee-variable/source-type
                         :fee-variable/fee-template
                         :fee-variable/source-field
                         :fee-variable/fee-formula]))
